import { Component, OnInit, inject } from '@angular/core';
import { faPrint } from '@fortawesome/pro-light-svg-icons';
import { Actions, ofType } from '@ngrx/effects';
import * as fromInvoiceDocumentActions from '../../../../../core/state/invoice-documents/invoice-document.actions';
import { map } from 'rxjs/operators';
import { InvoiceDocumentDetailModel } from '../../../../../core/models/invoice/invoice-document-detail.model';
import { GeneratePdfPostModel } from '../../../../../core/models/pdf/generate-pdf-post.model';
import { InvoiceDocumentHttpService } from '../../../../../core/state/invoice-documents/invoice-document-http.service';
import { SortableElementsStorageService } from '../../../../../core/services/features/sortable-elements/sortable-elements-storage.service';
import { GeneratePdfHttpService } from '../../../../../core/state/pdf-generation/generate-pdf-http.service';
import { assert } from '../../../../../core/assert/assert';
import { InvoiceStateService } from '../../invoice-creation-editing/state-and-data-handling/invoice-state.service';

@Component({
  selector: 'app-invoice-page-footer',
  standalone: false,
  templateUrl: './invoice-page-footer.component.html',
})
export class InvoicePageFooterComponent implements OnInit {
  public readonly faPrint = faPrint;

  // DI
  public readonly invoiceStateService = inject(InvoiceStateService);
  private readonly actions$ = inject(Actions);
  private readonly invoiceDocumentHttpService = inject(InvoiceDocumentHttpService);
  private readonly sortableRowsStorageService = inject(SortableElementsStorageService);
  private readonly generatePdfHttpService = inject(GeneratePdfHttpService);

  ngOnInit(): void {
    this.initEvents();
  }

  public createOrUpdateDocument(isTemplate = false): void {
    const invoiceModel = new InvoiceDocumentDetailModel();
    invoiceModel.id = null;
    invoiceModel.contentAreas = this.invoiceStateService.contentAreas();
    invoiceModel.themeProps = this.invoiceStateService.themeProps();
    invoiceModel.theme = this.invoiceStateService.theme();
    invoiceModel.meta = this.invoiceStateService.meta();
    // Don't save invoice positions for a template:
    invoiceModel.positions = isTemplate ? [] : this.sortableRowsStorageService.clonedPositions();
    invoiceModel.isTemplate = isTemplate;
    const id = isTemplate ? -1 : this.invoiceStateService.invoiceId();

    if (id < 0) {
      // Post to create invoice or template.
      this.invoiceDocumentHttpService.generateInvoiceDocument(invoiceModel);
      return;
    }

    // Put
    invoiceModel.id = this.invoiceStateService.invoiceId();
    this.invoiceDocumentHttpService.updateInvoiceDocument(invoiceModel);
  }

  public createPdf(): void {
    assert(this.invoiceStateService.invoiceId() >= 0);

    const generatePdfPostModel = new GeneratePdfPostModel();
    generatePdfPostModel.invoiceId = this.invoiceStateService.invoiceId();

    this.generatePdfHttpService.generatePdf(generatePdfPostModel);
  }

  private initEvents(): void {
    this.actions$
      .pipe(
        ofType(fromInvoiceDocumentActions.invoiceDocumentGenerated),
        map((entry) => entry.payload),
      )
      .subscribe((newInvoice) => {
        this.invoiceStateService.invoiceId.set(newInvoice.id);
      });
  }
}
